import { render, staticRenderFns } from "./AlternativeTableRow.vue?vue&type=template&id=70bb9525&scoped=true&"
import script from "./AlternativeTableRow.vue?vue&type=script&lang=js&"
export * from "./AlternativeTableRow.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeTableRow.vue?vue&type=style&index=0&id=70bb9525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb9525",
  null
  
)

export default component.exports